import currencyRequest from '@Bill/mixins/currencyRequest'
import {
  getNameDescriptionTableColumn,
} from '@/utils/common/tableColumn'

export default {
  mixins: [currencyRequest],
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        edit: false,
        editDesc: false,
        showDesc: false,
        addBackup: true,
        sortable: true,
        field: 'month',
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ this.monthFormatter(row.month) }</side-page-trigger>
          )
        },
      }),
      // {
      //   field: 'amount',
      //   title: i18n.t('bill.text_308'),
      //   sortable: true,
      //   formatter: ({ row }) => {
      //     let sign = ''
      //     if (currencyUnitMap[this.currency]) {
      //       sign = currencyUnitMap[this.currency].sign || ''
      //     }
      //     return `${sign}${numerify(row.amount, '0,0.00')}`
      //   },
      // },
      // {
      //   field: 'year_amount',
      //   title: i18n.t('bill.text_139'),
      //   // sortable: true,
      //   formatter: ({ row }) => {
      //     let sign = ''
      //     if (currencyUnitMap[this.currency]) {
      //       sign = currencyUnitMap[this.currency].sign || ''
      //     }
      //     return `${sign}${numerify(row.year_amount, '0,0.00')}`
      //   },
      // },
    ]
  },
  methods: {
    monthFormatter (time) {
      return `${time.toString().substr(0, 4)}-${time.toString().substr(4, 2)}`
    },
  },
}
